import { render, staticRenderFns } from "./add-assignment.html?vue&type=template&id=6ecdedf0&scoped=true&"
import script from "./add-assignment.js?vue&type=script&lang=js&"
export * from "./add-assignment.js?vue&type=script&lang=js&"
import style0 from "./add-assignment.css?vue&type=style&index=0&id=6ecdedf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecdedf0",
  null
  
)

export default component.exports